import fetch from "auth/FetchInterceptor";
import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";
import { checkHaveToken } from "constants/actionAccess";
import { orderStatusMode } from "pages/Orders/utils";
import { CREATE_MODE } from "constants/order";

const orderService = {};

orderService.getStatus = () => {
  return fetch({
    url: `${env.API_MSP}/orders/list-status`,
    method: "get",
  });
};

orderService.getTransferOrderStatus = () => {
  return fetch({
    url: `${env.API_MSP}/orders/list-status-transfer-order`,
    method: "get",
  });
};

orderService.getOrder = ({ orderId }) => {
  return fetchV2({
    url: `${env.API_MSP}/orders/${orderId}`,
    method: "get",
    params: {
      expand: "mainNote,transport_group_code,noted_reason_type",
    },
  });
};
orderService.getOrderHistory = ({ orderId }) => {
  return fetch({
    url: `${env.API_MSP}/orders/${orderId}/history`,
    method: "get",
  });
};
orderService.getOrderAttachments = ({ orderId }) => {
  return fetch({
    url: `${env.API_MSP}/orders/${orderId}/list-image`,
    method: "get",
  });
};

// List My Orders
orderService.listMyOrders = ({ params }) => {
  const columnFilter = params.columnFilter || {};
  return fetch({
    url: `${env.API_MSP}/my-orders`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      "filter[record_status]": "O",
    },
  });
};

// List Orders
orderService.listOrders = ({ params }) => {
  const columnFilter = params.columnFilter || {};
  return fetch({
    url: `${env.API_MSP}/orders`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort,
      keywords: params.keywords || "",
      expand: params?.expand || "",
      "filter[record_status]": "O",
      "filter[is_transfer_order]": 0,
    },
  });
};

// List Orders
orderService.listOrdersActive = ({ params }) => {
  const columnFilter = params.columnFilter || {};
  return fetchV2({
    url: `${env.API_MSP}/orders`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params?.expand || "",
      "filter[record_status]": "O",
      "filter[status][nin][1]": orderStatusMode.COMPLETED,
      "filter[status][nin][2]": orderStatusMode.CANCELED,
      "filter[status][nin][3]": orderStatusMode.DELIVERED,
      "filter[is_transfer_order]": 0,
    },
  });
};

orderService.getTransferOrder = ({ orderId }) => {
  return fetchV2({
    url: `${env.API_MSP}/order-transfers/${orderId}`,
    method: "get",
    params: {
      expand:
        "from_hub_is_center,sender_province_name,sender_disitrct_name,sender_ward_name,reciever_province_name,reciever_district_name,reciever_ward_name,from_hub_name,to_hub_name",
    },
  });
};

// List Transfer Orders
orderService.listTransferOrders = ({ params }) => {
  const columnFilter = params.columnFilter || {};
  return fetch({
    url: `${env.API_MSP}/order-transfers`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      expand: params?.expand || "",
      keywords: params.keywords || "",
      "filter[orderstatus]": "O",
    },
  });
};

// List NewSendOrderScanTotal
orderService.listNewSendOrderScanTotal = ({ params }) => {
  const columnFilter = params.columnFilter || {};
  return fetch({
    url: `${env.API_MSP}/orders/new-send-order-scan-total`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params?.expand || "",
      // "filter[record_status]": "O",
    },
  });
};

//Delete order
orderService.deleteOrder = ({ orderId = undefined }) => {
  return fetch({
    url: `${env.API_MSP}/my-orders/${orderId}`,
    method: "delete",
  });
};

// List Orders Reminder
orderService.listOrderReminder = ({ params }) => {
  // const columnFilter = params.columnFilter || {};
  return fetch({
    url: `${env.API_MSP}/order-reminders`,
    method: "get",
    params: {
      // ...columnFilter,
      // page: params.page || 1,
      // "per-page": params.sizePerPage || 10,
      // sort: params.sort || "-maker_date",
      // keywords: params.keywords || "",
      "filter[record_status]": "O",
      "filter[order_id]": params,
    },
  });
};
orderService.deleteOrderReminder = id => {
  return fetchV2({
    url: `${env.API_MSP}/order-reminders/${id}`,
    method: "delete",
  });
};

//Cancel order
orderService.cancelOrder = ({
  orderId = undefined,
  order_code,
  reason_note,
  reason_id,
}) => {
  return fetch({
    url: `${env.API_MSP}/orders/${orderId}/cancel`,
    method: "post",
    data: {
      order_code,
      reason_note,
      reason_id,
    },
  });
};

// List reason why delete order
orderService.reasonList = type => {
  return fetch({
    url: `${env.API_MSP}/reason`,
    method: "get",
    params: {
      "filter[type]": type,
    },
  });
};

//List type order
orderService.listTypeOrder = () => {
  if (!checkHaveToken()) {
    return false;
  }
  return fetch({
    url: `${env.API_MSP}/orders/list-type-order`,
    method: "get",
  });
};

// create order
orderService.createOrder = data => {
  return fetch({
    url: `${env.API_MSP}/orders`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// createOrderGetGoods
orderService.createOrderGetGoods = data => {
  return fetch({
    url: `${env.API_MSP}/orders/group-receive`,
    method: "post",
    data: {
      ...data,
      create_mode: data?.create_mode ?? CREATE_MODE.WITH_CHILDREN,
    },
  });
};

// create TransferOrder
orderService.createTransferOrder = data => {
  return fetch({
    url: `${env.API_MSP}/order-transfers`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// create TransferOrder
orderService.copyTransferOrder = ({ orderId, data }) => {
  return fetch({
    url: `${env.API_MSP}/order-transfers/${orderId}/create-transfer-order-from-one`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// searchOrdersByCode
orderService.searchOrdersByCode = order_code => {
  return fetch({
    url: `${env.API_MSP}/orders`,
    method: "get",
    params: {
      "filter[order_code]": order_code,
    },
  });
};

//forward order
orderService.forwardOrder = data => {
  const dataCustomer = {
    customer_contact_name: data?.customer_contact_name || "",
    customer_contact_phone: data?.customer_contact_phone || "",
    customer_address: data?.customer_address || "",
    customer_ward_code: data?.customer_ward_code || null,
    customer_district_code: data?.customer_district_code || null,
    customer_province_code: data?.customer_province_code || null,
  };

  return fetchV2({
    url: `${env.API_MSP}/orders/${data.order_id}/forward-order`,
    method: "post",
    data: {
      transport_id: data?.transport_id || null,
      runner_id: data?.runner_id,
      bus_id: data?.bus_id || null,
      shipping_type: data?.shipping_type || "",
      note: data?.note || "",
      action_date: data?.action_date || "",
      timeslot_id: data?.timeslot_id || 0,
      ...(data?.customer_contact_name ? dataCustomer : {}),
    },
  });
};

orderService.forwardOrderMultiple = data => {
  const dataCustomer = {
    customer_contact_name: data?.customer_contact_name || "",
    customer_contact_phone: data?.customer_contact_phone || "",
    customer_address: data?.customer_address || "",
    customer_ward_code: data?.customer_ward_code || null,
    customer_district_code: data?.customer_district_code || null,
    customer_province_code: data?.customer_province_code || null,
  };

  return fetchV2({
    url: `${env.API_MSP}/orders/forward-multiple-order`,
    method: "post",
    data: {
      transport_id: data?.transport_id || null,
      runner_id: data?.runner_id,
      bus_id: data?.bus_id || null,
      shipping_type: data?.shipping_type || "",
      note: data?.note || "",
      action_date: data?.action_date || "",
      timeslot_id: data?.timeslot_id || 0,
      ids: data?.ids,
      ...(data?.customer_contact_name ? dataCustomer : {}),
    },
  });
};

orderService.exportOrders = ({ params, excelParams }) => {
  const columnFilter = params.columnFilter || {};
  return fetch({
    url: `${env.API_MSP}/orders/export`,
    method: "get",
    timeout: 60000,
    params: {
      ...columnFilter,
      maker_id: params.maker_id || "",
      keywords: params.keywords || "",
      "filter[record_status]": "O",
      expand: "maker",
      ...excelParams,
      sort: "-maker_date",
    },
    responseType: "arraybuffer",
  });
};

orderService.exportOrdersActive = ({ params, excelParams }) => {
  const columnFilter = params.columnFilter || {};
  return fetch({
    url: `${env.API_MSP}/orders/export`,
    method: "get",
    timeout: 60000,
    params: {
      ...columnFilter,
      maker_id: params.maker_id || "",
      keywords: params.keywords || "",
      "filter[record_status]": "O",
      expand: "maker",
      ...excelParams,
      "filter[status][nin][1]": 5,
      "filter[status][nin][2]": 7,
      sort: "-maker_date",
    },
    responseType: "arraybuffer",
  });
};

orderService.exportMyOrders = ({ params, excelParams }) => {
  const columnFilter = params.columnFilter || {};
  return fetch({
    url: `${env.API_MSP}/my-orders/export`,
    method: "get",
    timeout: 60000,
    params: {
      ...columnFilter,
      maker_id: params.maker_id || "",
      keywords: params.keywords || "",
      "filter[record_status]": "O",
      expand: "maker",
      ...excelParams,
      sort: "-maker_date",
    },
    responseType: "arraybuffer",
  });
};

// change order status
orderService.changeOrderStatus = data => {
  return fetchV2({
    url: `${env.API_MSP}/orders/${data.order_id}/change-status`,
    method: "post",
    data: {
      status: data?.status,
      note: data?.note,
    },
  });
};

orderService.changeOrderStatusMultiple = data => {
  return fetchV2({
    url: `${env.API_MSP}/orders/change-status-multiple-order`,
    method: "post",
    data: {
      status: data?.status,
      note: data?.note,
      ids: data?.ids,
    },
  });
};

// Change Order Customer
orderService.changeOrderCustomer = ({ orderId = undefined, data = {} }) => {
  return fetchV2({
    url: `${env.API_MSP}/orders/${orderId}/change-customer`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// Change Order Sale
orderService.changeOrderSale = ({ orderId, data }) => {
  return fetchV2({
    url: `${env.API_MSP}/orders/${orderId}/change-sale`,
    method: "post",
    data,
  });
};

//inser order refcode
orderService.insertRefCode = data => {
  return fetch({
    url: `${env.API_MSP}/orders/insert-ref-code`,
    method: "post",
    data,
  });
};

//update exist order refcode
orderService.updateExistRefCode = data => {
  return fetch({
    url: `${env.API_MSP}/orders/update-ref-code`,
    method: "post",
    data,
  });
};

// listChildOrders
orderService.listChildOrders = ({ params }) => {
  const columnFilter = params.columnFilter || {};
  return fetch({
    url: `${env.API_MSP}/orders`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      "filter[record_status]": "O",
      "filter[parent_id]": params.parent_id,
    },
  });
};

// removeOrderChild
orderService.removeOrderChild = ({ orderChildId }) => {
  return fetchV2({
    url: `${env.API_MSP}/orders/${orderChildId}/remove-child`,
    method: "post",
  });
};

/**
 * Refund Order
 * @param {{
 *  orderId: string | number;
 *  data: {
 *    note: string;
 *  };
 * }} val
 */
orderService.refundOrder = ({ orderId, data }) => {
  return fetchV2({
    url: `${env.API_MSP}/orders/${orderId}/return`,
    method: "post",
    data,
  });
};

orderService.addReceiveBusChild = data => {
  return fetch({
    url: `${env.API_MSP}/orders/add-receive-bus-child`,
    method: "post",
    data,
  });
};

// AddChildOrders
orderService.addChildTransferOrders = ({ order_id, sub_order_codes = [] }) => {
  return fetch({
    url: `${env.API_MSP}/order-transfers/${order_id}/add-child-orders`,
    method: "post",
    data: {
      sub_order_codes,
    },
  });
};

// RemoveChildTransferOrder
orderService.removeChildTransferOrder = ({ order_codes = [] }) => {
  return fetch({
    url: `${env.API_MSP}/order-transfers/remove-child-transfer-order`,
    method: "post",
    data: {
      order_codes,
    },
  });
};

//Cancel transfer order
orderService.cancelTransferOrder = ({
  orderId = undefined,
  order_code,
  reason_note,
  reason_id,
}) => {
  return fetch({
    url: `${env.API_MSP}/order-transfers/${orderId}/cancel`,
    method: "post",
    data: {
      order_code,
      reason_note,
      reason_id,
    },
  });
};

//Attach image to order
orderService.attachImageToOrder = ({ order_id, data }) => {
  return fetch({
    url: `${env.API_MSP}/orders/${order_id}/upload-file`,
    method: "post",
    data,
  });
};

orderService.listNoteOrderReason = ({ params }) => {
  return fetch({
    url: `${env.API_MSP}/reason`,
    method: "get",
    params: {
      ...params,
      page: params.page || -1,
    },
  });
};

orderService.noteOrder = ({ order_id, data }) => {
  return fetch({
    url: `${env.API_MSP}/orders/${order_id}/note-order`,
    method: "post",
    data,
  });
};

orderService.mappingRefCodeUnknownToOrder = ({
  parent_id,
  ref_code,
  order_code,
}) => {
  return fetch({
    url: `${env.API_MSP}/orders/map-child`,
    method: "post",
    data: {
      order_id: parent_id,
      ref_code,
      order_code,
    },
  });
};

orderService.getOrderNotes = ({ order_id }) => {
  return fetch({
    url: `${env.API_MSP}/ajax/get-order-notes/${order_id}`,
    method: "get",
  });
};

// Update order cost
orderService.updateOrderCost = ({ orderId, cost_value }) => {
  return fetchV2({
    url: `${env.API_MSP}/orders/${orderId}/update-cost`,
    method: "post",
    data: {
      cost_value, 
    },
  });
};

orderService.countDeliveredPendingCompletion = ({ hub_ids }) => {
  return fetchV2({
    url: `${env.API_MSP}/orders/count-delivered-pending-completion`,
    method: "get",
    params: { hub_ids },
  });
};

export default orderService;
